import { useEffect, useState } from "react";
import api from "../../services/api";
import useWrapper from "../useWrapper";

const useSuppliers = (props = {}) => {
  const { query = "?" } = props;
  const { config } = useWrapper();

  const [load, setload] = useState(false);
  const [reload, setreload] = useState();
  const [suppliers, setsuppliers] = useState();
  useEffect(() => {
    if (load) {
      (async () => {
        try {
          const { data: _suppliers } = await api.get(`providers${query}`, config);
          setsuppliers(_suppliers);
        } catch (__err) {
          console.log("__err", __err);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render (src/context/WrapperContext.jsx, outside this file's scope); adding it would refire this fetch on unrelated context updates. `query` is included so a dynamic query still refetches correctly.
  }, [reload, load, query]);

  const reloadPage = () => {
    setreload(!reload);
  };
  const loadPage = () => {
    setload(true);
  };

  return {
    data: suppliers,
    load: loadPage,
    reload: reloadPage,
  };
};

export default useSuppliers;
